import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import dayjs from 'dayjs';
import { StyledButton } from '../../../../Components/Generics.styled';

const ReviewCampaignContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`;

const Title = styled.div`
    margin-top: 100px;
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    text-align: center;
`;

const ReviewApplet = styled.div`
    width: 100%;
    max-width: 800px;
    height: 100%;
    background: #fafbf7;
    border: 1px solid black;
    border-radius: 12px;
    padding: 12px;
    margin-left: auto;
    margin-right: auto;
`;

const StyledNavButtons = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;

    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const LabelValueSection = styled.div`
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    border-bottom: 1px solid black;
`;

const Label = styled.div`
    text-align: right;
    padding-right: 12px;
    font-size: 16px;
    color: #707070;
    opacity: 1;
`;
const FileContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const LabelValue = styled.div``;

const ReviewCampaign = (props) => {
    const { campaignData, handleNavButtonBack, handleNavButtonNext, currentAdvertiser } = props;

    const [base64String, setBase64String] = useState('');

    function toBase64(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setBase64String(reader.result);
        };
        reader.onerror = () => (error) => {
            console.log(error, 'error converting to base64');
        };
    }

    const {
        campaignTypeCategoryName,
        advertiserName,
        campaignTypeName,
        startDate,
        endDate,
        campaignName,
        headline,
        headline2,
        headline3,
        headline4,
        headline5,
        headline6,
        description,
        description2,
        description3,
        description4,
        websiteURL,
        budget,
        googleCampaignKeywords,
        locations,
        file,
    } = { ...campaignData };

    const fileType = campaignData?.file?.file?.type;
    const isVideoOrAudioFile = fileType?.startsWith('video/') || fileType?.startsWith('audio/');
    useEffect(() => {
        if (file.file !== null && !isVideoOrAudioFile && file.file && file.file instanceof Blob) {
            toBase64(file.file);
        }
    }, [file]);

    const isGoogle = campaignData?.campaignTypeId === 1;
    const isProgrammatic = campaignData?.campaignTypeId === 26;
    const isMobile = campaignData?.campaignTypeId === 2;

    return (
        <ReviewCampaignContainer>
            <Title>Review your campaign</Title>
            <ReviewApplet>
                <br />
                <LabelValueSection>
                    <Label>Advertiser:</Label>
                    <LabelValue>{advertiserName}</LabelValue>
                </LabelValueSection>
                <br />
                <LabelValueSection>
                    <Label>Campaign Name:</Label>
                    <LabelValue style={{ width: '400px', wordWrap: 'break-word' }}>
                        {campaignName}
                    </LabelValue>
                </LabelValueSection>
                <br />
                <LabelValueSection>
                    <Label>Start and End Dates:</Label>
                    <LabelValue>{`${dayjs(startDate).format('MM/DD/YYYY')} - ${dayjs(
                        endDate
                    ).format('MM/DD/YYYY')}`}</LabelValue>
                </LabelValueSection>

                {isGoogle ? (
                    <>
                        <LabelValueSection>
                            <Label>Headline:</Label>
                            <LabelValue>{headline}</LabelValue>
                        </LabelValueSection>

                        <LabelValueSection>
                            <Label>Headline 2:</Label>
                            <LabelValue>{headline2}</LabelValue>
                        </LabelValueSection>
                        <LabelValueSection>
                            <Label>Headline 3:</Label>
                            <LabelValue>{headline3}</LabelValue>
                        </LabelValueSection>
                        <LabelValueSection>
                            <Label>Headline 4:</Label>
                            <LabelValue>{headline4}</LabelValue>
                        </LabelValueSection>
                        <LabelValueSection>
                            <Label>Headline 5:</Label>
                            <LabelValue>{headline5}</LabelValue>
                        </LabelValueSection>
                        <LabelValueSection>
                            <Label>Headline 6:</Label>
                            <LabelValue>{headline6}</LabelValue>
                        </LabelValueSection>

                        <LabelValueSection>
                            <Label> Description:</Label>
                            <LabelValue>{description}</LabelValue>
                        </LabelValueSection>
                        <LabelValueSection>
                            <Label> Description 2:</Label>
                            <LabelValue>{description2}</LabelValue>
                        </LabelValueSection>
                        <LabelValueSection>
                            <Label> Description 3:</Label>
                            <LabelValue>{description3}</LabelValue>
                        </LabelValueSection>
                        <LabelValueSection>
                            <Label> Description 4:</Label>
                            <LabelValue>{description4}</LabelValue>
                        </LabelValueSection>

                        <LabelValueSection>
                            <Label>Keywords:</Label>
                            <LabelValue
                                style={{
                                    width: '400px',
                                    height: '100%',
                                    wordWrap: 'break-word',
                                }}
                            >
                                {googleCampaignKeywords?.map((item, idx) => (
                                    <div key={idx}>{item}</div>
                                ))}
                            </LabelValue>
                        </LabelValueSection>
                    </>
                ) : null}
                <LabelValueSection>
                    <Label>Locations:</Label>
                    <LabelValue
                        style={{
                            width: '400px',
                            height: '100%',
                            wordWrap: 'break-word',
                        }}
                    >
                        {isGoogle || isMobile ? (
                            <div>
                                {locations?.map((item, idx) => (
                                    <div key={idx}>{item.canonicalName}</div>
                                ))}
                            </div>
                        ) : null}

                        {isProgrammatic ? (
                            <div>
                                {locations?.map((item, idx) => (
                                    <div
                                        key={idx}
                                    >{`${item.cityName}, ${item.countyName}, ${item.stateName}`}</div>
                                ))}
                            </div>
                        ) : null}
                    </LabelValue>
                </LabelValueSection>

                <br />
                <br />
                <LabelValueSection>
                    <Label>Campaign Type</Label>
                    <LabelValue>{campaignTypeName.toUpperCase()}</LabelValue>
                </LabelValueSection>
                <LabelValueSection>
                    <Label>Cateogry</Label>
                    <LabelValue>{campaignTypeCategoryName}</LabelValue>
                </LabelValueSection>

                <LabelValueSection>
                    <Label>Click URL:</Label>
                    <LabelValue>{websiteURL}</LabelValue>
                </LabelValueSection>
                <LabelValueSection>
                    <Label>Budget:</Label>
                    <LabelValue>${budget}</LabelValue>
                </LabelValueSection>

                <br />
                {file.file !== null && !isVideoOrAudioFile && !isGoogle ? (
                    <FileContainer>
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Selected File</div>
                        <img
                            style={{ objectFit: 'contain' }}
                            width="250px"
                            height="100px"
                            src={base64String}
                            alt="ad"
                        />
                    </FileContainer>
                ) : null}
                {file.file !== null && isVideoOrAudioFile && !isGoogle ? (
                    <FileContainer>
                        <video width="400" controls>
                            <source src={URL.createObjectURL(file.file)} type="video/mp4" />
                        </video>
                    </FileContainer>
                ) : null}
            </ReviewApplet>
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonBack()}
                >
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonNext()}
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </ReviewCampaignContainer>
    );
};

ReviewCampaign.propTypes = {
    campaignData: propTypes.shape({
        campaignTypeName: propTypes.string,
        campaignTypeId: propTypes.number,
        file: propTypes.shape({
            file: propTypes.shape({
                type: propTypes.string,
            }),
        }),
    }),
    handleNavButtonBack: propTypes.func,
    handleNavButtonNext: propTypes.func,
    currentAdvertiser: propTypes.shape({ companyName: propTypes.string }),
};

ReviewCampaign.defaultProps = {
    campaignData: {},
    setCampaignData: () => {},
};

export default ReviewCampaign;
